import KitFadeView from '@omni/kit/components/KitFadeView';
import KitText from '@omni/kit/components/KitText';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import formatTimeDurationHMS from '@omni/kit/utilities/formatDurationHMS';
import { transparentHexColor } from '@omni/kit/utilities/utilities';
import React, { ReactElement, useCallback, useMemo } from 'react';
import { StyleSheet } from 'react-native';

export interface PlayerTimestampsProps {
  isVisible?: boolean;
  currentTime: number;
  totalDurationSeconds?: number;
  isLive?: boolean;
}

const FontSize = 16;

const PlayerTimestamps = ({
  isVisible,
  currentTime,
  totalDurationSeconds = -1,
  isLive,
}: PlayerTimestampsProps): ReactElement => {
  const currentTimeString = useMemo(
    () => formatTimeDurationHMS(currentTime) ?? '––:––',
    [currentTime]
  );

  const totalTimeString = useMemo(() => {
    return totalDurationSeconds
      ? formatTimeDurationHMS(totalDurationSeconds)
      : '––:––';
  }, [totalDurationSeconds]);

  return isLive ? (
    <KitFadeView show={isVisible} style={[styles.timestamps]} keepElementSize>
      <KitText white semiBold fontSize={FontSize} style={[styles.text]}>
        {currentTimeString}
      </KitText>
    </KitFadeView>
  ) : (
    <KitFadeView
      show={isVisible ? Boolean(totalTimeString) : false}
      style={[styles.timestamps]}
      keepElementSize
    >
      <KitText white semiBold fontSize={FontSize} style={[styles.text]}>
        {currentTimeString}
      </KitText>
      <KitText
        white
        fontSize={FontSize}
        style={[styles.text, styles.textDevided]}
      >
        /
      </KitText>
      <KitText
        white
        fontSize={FontSize}
        style={[styles.text, styles.textRight]}
      >
        {totalTimeString}
      </KitText>
    </KitFadeView>
  );
};

const styles = StyleSheet.create({
  text: {
    includeFontPadding: false,
    textShadowColor: transparentHexColor(Colors.N1000, 30),
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 12,
    lineHeight: 22,
    textAlign: 'center',
  },
  textDevided: {
    opacity: 0.8,
    marginLeft: Spacing.xs,
    marginRight: Spacing.xs,
  },
  textRight: {
    opacity: 0.8,
  },
  timestamps: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default PlayerTimestamps;
